import { render, staticRenderFns } from "./SelectorCategorie.vue?vue&type=template&id=f4660746&scoped=true&"
import script from "./SelectorCategorie.vue?vue&type=script&lang=js&"
export * from "./SelectorCategorie.vue?vue&type=script&lang=js&"
import style0 from "./SelectorCategorie.vue?vue&type=style&index=0&id=f4660746&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4660746",
  null
  
)

export default component.exports